export const FORM_URL = '/api/proxy/form';
export const FORM_SUBMIT_URL = `${FORM_URL}/submit`;
